export default "__VITE_ASSET__XgFVRcJH__"